/* Souperstar group ordering (preview build 2026-11-02).
   Phase 1: one remembered "Name label" (localStorage) added as a line-item property to items added to the cart.
   Phase 2: /pages/group-order relay links ("Send my items to organiser"). No backend.
   Bulk lines (bulk-soup-30 / bulk-popiah-30, _bundle starting with "K" or a "Bulk order" property) never get a name and are never relayed.
   Tracking (2026-11-02): SSGroup.track() publishes custom events (Shopify.analytics.publish, for Customer Events pixels) and
   forwards to gtag/dataLayer only if the page already has them. No names or group names are sent. */
(function () {
  if (window.SSGroup) return;
  var KEY = 'ssNameLabel', GKEY = 'ssGroupName', DONE = 'ssGroupAdded', PROP = 'Name label', MAX = 40;
  var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';

  function clean(s) { return String(s || '').replace(/[,\r\n\t]/g, ' ').replace(/\s+/g, ' ').replace(/^[_\s]+/, '').trim().slice(0, MAX); }
  function store(k, v) {
    try {
      if (v === undefined) return localStorage.getItem(k) || '';
      if (v) localStorage.setItem(k, v); else localStorage.removeItem(k);
    } catch (e) { return ''; }
  }
  function getName() { return clean(store(KEY)); }
  function setName(v) {
    v = clean(v); store(KEY, v); syncInputs(v); paintPill();
    try { document.dispatchEvent(new CustomEvent('ss:namelabel', { detail: { name: v } })); } catch (e) {}
    return v;
  }
  function isBulkProps(p) { return !!p && ((typeof p._bundle === 'string' && p._bundle.charAt(0) === 'K') || !!p['Bulk order']); }
  /* 3 Nov 2026: Dashi packs (window.SSNoGroup, tag Dashi / Shipping only) are never part of a group order. */
  function noGroup(x) { var N = window.SSNoGroup; if (!N || !x) return false; var v = String(x.variant_id || x.id || ''); return (!!v && (N.v || []).indexOf(v) > -1) || (!!x.handle && (N.h || []).indexOf(x.handle) > -1); }
  function isGuest() { try { return localStorage.getItem('ssGroupRole') === 'guest'; } catch (e) { return false; } }
  function isShipOnlyLine(it) { return /dashi/i.test(it.product_type || '') && !/combo/i.test(it.product_type || ''); } /* Dashi (3 Nov 2026): shipping-only, never relayed */
  function isBulkLine(it) { return isBulkProps(it.properties) || /^bulk-/.test(it.handle || '') || isShipOnlyLine(it); }

  /* 1. Every JSON add to cart (quick-add, tile stepper, bundle sheet/picker, Mix-8) gets the remembered name,
        unless it already has a Name label or it is a bulk order. The product-page form sends its own field. */
  var nativeFetch = window.fetch;
  if (nativeFetch) {
    window.fetch = function (input, init) {
      try {
        var url = typeof input === 'string' ? input : (input && input.url) || '';
        var path = url.split('?')[0].split('#')[0];
        var n = getName();
        if (n && init && typeof init.body === 'string' && /\/cart\/add(\.js)?$/.test(path) && String(init.method || '').toUpperCase() === 'POST' && init.body.charAt(0) === '{') {
          var b = JSON.parse(init.body);
          var items = b.items || (b.id ? [b] : null);
          if (items && isGuest() && items.some(noGroup)) {
            var m = (window.SSNoGroup && SSNoGroup.msg) || 'Not available for group orders.';
            try { document.dispatchEvent(new CustomEvent('ss:nogroup', { detail: { message: m } })); } catch (e) {}
            return Promise.resolve(new Response(JSON.stringify({ status: 422, message: m, description: m }), { status: 422, headers: { 'Content-Type': 'application/json' } }));
          }
          if (items && !items.some(function (it) { return isBulkProps(it.properties); })) {
            items.forEach(function (it) {
              if (noGroup(it)) return;
              it.properties = it.properties || {};
              if (!Object.prototype.hasOwnProperty.call(it.properties, PROP)) it.properties[PROP] = n;
            });
            init = Object.assign({}, init, { body: JSON.stringify(b) });
          }
        }
      } catch (e) {}
      return nativeFetch.call(window, input, init);
    };
  }

  /* 2. Product-page "Name label" fields: prefill, remember, and only submit when filled (a blank property would split lines). */
  function syncInputs(v) {
    document.querySelectorAll('[data-ss-namelabel-input]').forEach(function (inp) {
      if (document.activeElement !== inp) inp.value = v;
      setInputName(inp);
    });
  }
  function setInputName(inp) {
    if (clean(inp.value)) inp.setAttribute('name', 'properties[' + PROP + ']'); else inp.removeAttribute('name');
  }
  document.addEventListener('input', function (e) {
    var inp = e.target.closest && e.target.closest('[data-ss-namelabel-input]');
    if (!inp) return;
    setInputName(inp);
    clearTimeout(inp._ssT);
    inp._ssT = setTimeout(function () { setName(inp.value); }, 250);
  });
  document.addEventListener('change', function (e) {
    var inp = e.target.closest && e.target.closest('[data-ss-namelabel-input]');
    if (!inp) return;
    inp.value = setName(inp.value);
    setInputName(inp);
  });
  document.addEventListener('submit', function (e) {
    var f = e.target; if (!f || !f.querySelectorAll) return;
    f.querySelectorAll('[data-ss-namelabel-input]').forEach(function (inp) { inp.value = clean(inp.value); setInputName(inp); });
  }, true);

  /* 3. A small pill so nobody adds items under a name by surprise. */
  var pill;
  function paintPill() {
    var n = getName();
    if (!n) { if (pill) pill.hidden = true; return; }
    if (!pill) {
      pill = document.createElement('div');
      pill.className = 'ss-np'; pill.setAttribute('role', 'status');
      pill.innerHTML = '<span>Name label: <b data-n></b></span><button type="button" data-ch>Change</button><button type="button" data-x aria-label="Stop adding a name label">&times;</button>';
      pill.querySelector('[data-ch]').addEventListener('click', function () {
        var v = window.prompt('Name label for the next items you add (max 40 characters):', getName());
        if (v !== null) setName(v);
      });
      pill.querySelector('[data-x]').addEventListener('click', function () { setName(''); });
      document.body.appendChild(pill);
    }
    pill.querySelector('[data-n]').textContent = n;
    pill.hidden = false;
  }
  var css = '.ss-np{position:fixed;left:12px;bottom:12px;z-index:25;display:flex;align-items:center;gap:6px;max-width:calc(100% - 24px);background:#1f1a17;color:#fff;border-radius:999px;padding:6px 6px 6px 14px;font-size:13px;line-height:1.2;box-shadow:0 4px 16px rgba(0,0,0,.2)}' +
    '.ss-np[hidden]{display:none}.ss-np span{overflow:hidden;text-overflow:ellipsis;white-space:nowrap}' +
    '.ss-np button{border:0;background:#3a332e;color:#fff;border-radius:999px;padding:6px 10px;font-size:12px;cursor:pointer;flex:0 0 auto}' +
    '.ss-np button[data-x]{background:none;font-size:18px;padding:2px 8px}' +
    '@media (max-width:768px){body.ss-has-sticky .ss-np{bottom:84px}}' +
    '.ss-namelabel{margin:0 0 14px}.ss-namelabel label{display:block;font-size:13px;font-weight:600;margin:0 0 6px}.ss-namelabel label span{font-weight:400;color:#8a7f77}' +
    '.ss-namelabel input{width:100%;max-width:100%}.ss-namelabel__help{font-size:12px;color:#6f6660;margin:6px 0 0}';
  var st = document.createElement('style'); st.textContent = css; document.head.appendChild(st);

  /* 4. Group-order page helpers (used by sections/ss-group-order.liquid). */
  function b64urlEncode(obj) {
    var s = unescape(encodeURIComponent(JSON.stringify(obj)));
    return btoa(s).replace(/\+/g, '-').replace(/\//g, '_').replace(/=+$/, '');
  }
  function b64urlDecode(str) {
    str = String(str || '').replace(/-/g, '+').replace(/_/g, '/');
    while (str.length % 4) str += '=';
    return JSON.parse(decodeURIComponent(escape(atob(str))));
  }
  function getCart() { return nativeFetch.call(window, root + 'cart.js', { headers: { Accept: 'application/json' }, credentials: 'same-origin' }).then(function (r) { return r.json(); }); }
  function myLines(cart, name) {
    return (cart.items || []).filter(function (it) { return !isBulkLine(it) && !noGroup(it) && it.properties && it.properties[PROP] === name; });
  }
  function buildRelay(cart, name, group) {
    var lines = myLines(cart, name);
    if (!lines.length) return null;
    var payload = {
      v: 1, id: Date.now().toString(36) + Math.random().toString(36).slice(2, 6), n: name, g: clean(group),
      i: lines.map(function (it) {
        var p = {}; Object.keys(it.properties || {}).forEach(function (k) { var x = it.properties[k]; if (x !== null && x !== '') p[k] = String(x); });
        return [it.variant_id, it.quantity, p, it.product_title + (it.variant_title ? ' (' + it.variant_title + ')' : '')];
      })
    };
    var base = location.origin + location.pathname;
    return { url: base + '?add=' + b64urlEncode(payload), lines: lines, payload: payload };
  }
  function readRelay(param) {
    var d = b64urlDecode(param);
    if (!d || d.v !== 1 || !Array.isArray(d.i)) throw new Error('bad link');
    d.n = clean(d.n); d.g = clean(d.g);
    d.i = d.i.filter(function (x) { return Array.isArray(x) && +x[0] > 0 && +x[1] > 0 && !isBulkProps(x[2]) && !noGroup({ id: x[0] }); }).slice(0, 50).map(function (x) {
      var p = {}; var src = x[2] || {};
      Object.keys(src).forEach(function (k) { if (typeof src[k] === 'string' && k.length <= 60) p[k] = src[k].slice(0, 500); });
      p[PROP] = d.n; /* always the sender's name */
      return { id: +x[0], quantity: Math.min(+x[1], 99), properties: p, title: String(x[3] || '').slice(0, 120) };
    });
    return d;
  }
  function addedList() { try { return JSON.parse(store(DONE) || '{}'); } catch (e) { return {}; } }
  function markAdded(id) { var m = addedList(); m[id] = Date.now(); var ks = Object.keys(m); if (ks.length > 100) delete m[ks[0]]; store(DONE, JSON.stringify(m)); }
  function addRelay(d) {
    var items = d.i.map(function (x) { return { id: x.id, quantity: x.quantity, properties: x.properties }; });
    return nativeFetch.call(window, root + 'cart/add.js', {
      method: 'POST', credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: items })
    }).then(function (r) { return r.json().then(function (j) { if (!r.ok) throw j; markAdded(d.id); return j; }); });
  }

  /* 5. Tracking. Custom events for Customer Events pixels; gtag / dataLayer only if already on the page (no new tags). */
  var EVLOG = [];
  function currency() { try { return (Shopify.currency && Shopify.currency.active) || 'SGD'; } catch (e) { return 'SGD'; } }
  /* opts.beacon + opts.callback (GA4 fix 2026-11-02): send with transport_type 'beacon' and call back once GA has it
     (or after opts.timeout ms, default 800), so a page navigation right after the event doesn't drop it. */
  function track(name, data, opts) {
    var d = {}; Object.keys(data || {}).forEach(function (k) { if (data[k] !== undefined && data[k] !== null) d[k] = data[k]; });
    var sent = [], cb = opts && typeof opts.callback === 'function' ? opts.callback : null, fired = false;
    var done = function () { if (!fired) { fired = true; if (cb) cb(); } };
    if (cb) setTimeout(done, (opts && opts.timeout) || 800);
    try { if (window.Shopify && Shopify.analytics && typeof Shopify.analytics.publish === 'function') { Shopify.analytics.publish(name, d); sent.push('shopify'); } } catch (e) {}
    try {
      var gd = opts && opts.beacon ? Object.assign({ transport_type: 'beacon', event_callback: done, event_timeout: (opts.timeout || 800) }, d) : d;
      if (typeof window.gtag === 'function') { window.gtag('event', name, gd); sent.push('gtag'); }
      else if (window.dataLayer && typeof window.dataLayer.push === 'function') { window.dataLayer.push(Object.assign({ event: name }, d, cb ? { eventCallback: done, eventTimeout: (opts.timeout || 800) } : {})); sent.push('dataLayer'); }
    } catch (e) {}
    if (cb && sent.indexOf('gtag') < 0 && sent.indexOf('dataLayer') < 0) done();
    EVLOG.push({ name: name, data: d, sent: sent, t: Date.now() }); if (EVLOG.length > 50) EVLOG.shift();
    return sent;
  }
  /* The organiser role, shared with ss-group-cart.js. group_order_start fires only when the role changes to organiser. */
  var ROLE = 'ssGroupRole', STARTED = 'ssGroupStartedAt';
  function becomeOrganiser(source) {
    var was = store(ROLE);
    store(ROLE, 'organiser');
    if (was !== 'organiser') { store(STARTED, String(Date.now())); track('group_order_start', { source: source || 'unknown', has_group_name: !!clean(store(GKEY)) }); return true; }
    if (!store(STARTED)) store(STARTED, String(Date.now()));
    return false;
  }
  function recentOrganiser(hours) {
    if (store(ROLE) !== 'organiser') return false;
    var t = +store(STARTED) || 0; return t > 0 && (Date.now() - t) < (hours || 72) * 3600000;
  }

  window.SSGroup = {
    PROP: PROP, clean: clean, getName: getName, setName: setName,
    getGroup: function () { return clean(store(GKEY)); }, setGroup: function (g) { g = clean(g); store(GKEY, g); return g; },
    noGroup: noGroup, getCart: getCart, myLines: myLines, buildRelay: buildRelay, readRelay: readRelay,
    wasAdded: function (id) { return !!addedList()[id]; }, addRelay: addRelay,
    track: track, events: EVLOG, currency: currency, becomeOrganiser: becomeOrganiser, recentOrganiser: recentOrganiser
  };

  function init() { syncInputs(getName()); paintPill(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();
